var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/SelectFollows/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import axios from "axios";
import debounce from "lodash.debounce";
import React, { useCallback, useEffect, useState } from "react";
import { DEFAULT_ENV, ENV_CONFIG, minifyQuery } from "../FieldPass/utils";
import NoResults from "../NoResults";
// Using the same query whose response contains excess fields, but is still better because it will be cached
import { GET_TEAMS } from "../SelectFavoriteWithData/query";
import SelectFollowsTabsContainer from "../SelectFollowsTabsContainer";
import Spinner from "../Spinner";
import { NoResultsContainer, SearchInput, SearchResults, SelectFollowsContainer, SpinnerContainer } from "./styles";
import { normalizeSearchResults, normalizeTeams } from "./utils";
var ComponentKey = "select-follows";
var SelectFollows = function SelectFollows(_ref) {
  var _ref$ariaLabelReset = _ref.ariaLabelReset,
    ariaLabelReset = _ref$ariaLabelReset === void 0 ? "Clear Players & Teams Search" : _ref$ariaLabelReset,
    className = _ref.className,
    containerProps = _ref.containerProps,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? DEFAULT_ENV : _ref$env,
    favoriteId = _ref.favoriteId,
    followedPlayers = _ref.followedPlayers,
    followedTeams = _ref.followedTeams,
    _ref$followingLabel = _ref.followingLabel,
    followingLabel = _ref$followingLabel === void 0 ? "FOLLOWING" : _ref$followingLabel,
    _ref$followLabel = _ref.followLabel,
    followLabel = _ref$followLabel === void 0 ? "FOLLOW" : _ref$followLabel,
    _ref$noResultsCopy = _ref.noResultsCopy,
    noResultsCopy = _ref$noResultsCopy === void 0 ? "We're sorry, we couldn't find any results for" : _ref$noResultsCopy,
    noResultsContainerProps = _ref.noResultsContainerProps,
    onFilterClick = _ref.onFilterClick,
    onFollowClick = _ref.onFollowClick,
    onSearchChange = _ref.onSearchChange,
    onSearchClick = _ref.onSearchClick,
    onSearchReset = _ref.onSearchReset,
    onTabClick = _ref.onTabClick,
    _ref$placeholderCopy = _ref.placeholderCopy,
    placeholderCopy = _ref$placeholderCopy === void 0 ? "Search Players & Teams" : _ref$placeholderCopy,
    _ref$playersTabName = _ref.playersTabName,
    playersTabName = _ref$playersTabName === void 0 ? "Players" : _ref$playersTabName,
    resultsContainerProps = _ref.resultsContainerProps,
    searchProps = _ref.searchProps,
    tabsContainerProps = _ref.tabsContainerProps,
    _ref$teamsTabName = _ref.teamsTabName,
    teamsTabName = _ref$teamsTabName === void 0 ? "Teams" : _ref$teamsTabName;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    teams = _useState2[0],
    setTeams = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var _useState5 = useState({
      isLoading: false,
      players: null,
      teams: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    searchResults = _useState6[0],
    setSearchResults = _useState6[1];
  useEffect(function () {
    var controller = new AbortController();
    function getTeams() {
      return _getTeams.apply(this, arguments);
    }
    function _getTeams() {
      _getTeams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _res$data, _ref2, midfield, res, _ref3, _teams;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _ref2 = ENV_CONFIG[env] || ENV_CONFIG[DEFAULT_ENV], midfield = _ref2.midfield;
                _context.next = 4;
                return axios.get("".concat(midfield, "?query=").concat(minifyQuery(GET_TEAMS)), {
                  headers: {
                    "apollo-require-preflight": true,
                    "apollographql-client-name": "publishing-services/account-components"
                  },
                  signal: controller.signal
                });
              case 4:
                res = _context.sent;
                _ref3 = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || {}, _teams = _ref3.teams;
                if (_teams) {
                  setTeams(_teams);
                }
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                if (!axios.isCancel(_context.t0)) {
                  // eslint-disable-next-line
                  console.error("[SelectFollows] getTeams request failed: ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message));
                }
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));
      return _getTeams.apply(this, arguments);
    }
    getTeams();
    return function () {
      return controller.abort();
    };
  }, []);
  useEffect(function () {
    if (query.length >= 3) {
      var controller = new AbortController();
      setSearchResults({
        isLoading: true,
        players: null,
        teams: null
      });
      getSearchResultsDebounced(query, controller);
      return function () {
        getSearchResultsDebounced.cancel();
        controller.abort();
      };
    }
  }, [env, query]);
  var getSearchResults = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query, controller) {
      var _ref5, typeahead, res, _ref6, players, _teams2;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _ref5 = ENV_CONFIG[env] || ENV_CONFIG[DEFAULT_ENV], typeahead = _ref5.typeahead;
              _context2.next = 4;
              return axios.get("".concat(typeahead).concat(query, "?sportId=1"), {
                signal: controller.signal
              });
            case 4:
              res = _context2.sent;
              _ref6 = (res === null || res === void 0 ? void 0 : res.data) || {}, players = _ref6.players, _teams2 = _ref6.teams;
              if (players || _teams2) {
                setSearchResults({
                  isLoading: false,
                  players: players,
                  teams: _teams2
                });
              }
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              if (!axios.isCancel(_context2.t0)) {
                setSearchResults({
                  isLoading: true,
                  players: null,
                  teams: null
                });
                // eslint-disable-next-line
                console.error("[SelectFollows] getSearchResults request failed: ".concat(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message));
              }
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return function (_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [env]);
  var getSearchResultsDebounced = useCallback(debounce(getSearchResults, 300), [env]);
  var onChange = function onChange(e) {
    var query = e.target.value.toLowerCase();
    setQuery(query);
    onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(e, query);
  };
  var onSearchInputClick = function onSearchInputClick(e) {
    onSearchClick === null || onSearchClick === void 0 ? void 0 : onSearchClick(e, query);
  };
  var onSearchResetClick = function onSearchResetClick(e) {
    setQuery("");
    onSearchReset === null || onSearchReset === void 0 ? void 0 : onSearchReset(e, query);
  };
  var normalizedTeams = normalizeTeams({
    favoriteId: favoriteId,
    followedTeams: followedTeams,
    followLabel: followLabel,
    followingLabel: followingLabel,
    teams: teams
  });
  var normalizedSearchResults = normalizeSearchResults({
    followedPlayers: followedPlayers,
    followedTeams: followedTeams,
    followLabel: followLabel,
    followingLabel: followingLabel,
    players: searchResults === null || searchResults === void 0 ? void 0 : searchResults.players,
    teams: searchResults === null || searchResults === void 0 ? void 0 : searchResults.teams
  });
  var renderContent = function renderContent() {
    /**
     * On initial render, there should be no query.
     */
    if (query.length < 3) {
      if (normalizedTeams) {
        return /*#__PURE__*/React.createElement(SelectFollowsTabsContainer, _extends({
          favoriteId: favoriteId,
          items: normalizedTeams,
          onFilterClick: onFilterClick,
          onFollowClick: onFollowClick,
          onTabClick: onTabClick,
          playersTabName: playersTabName,
          teamsTabName: teamsTabName
        }, tabsContainerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 169,
            columnNumber: 11
          }
        }));
      } else {
        return /*#__PURE__*/React.createElement(SpinnerContainer, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 182,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 183,
            columnNumber: 13
          }
        }));
      }
    } else {
      /**
       * When there is a query, differentiate between loading, results, and no results
       */
      if (searchResults.isLoading) {
        return /*#__PURE__*/React.createElement(SpinnerContainer, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 193,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194,
            columnNumber: 13
          }
        }));
      } else if (normalizedSearchResults.length > 0) {
        return /*#__PURE__*/React.createElement(SearchResults, _extends({
          favoriteId: favoriteId,
          items: normalizedSearchResults,
          onClick: onFollowClick
        }, resultsContainerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 199,
            columnNumber: 11
          }
        }));
      } else {
        return /*#__PURE__*/React.createElement(NoResultsContainer, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 208,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(NoResults, _extends({
          copy: noResultsCopy,
          query: query
        }, noResultsContainerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 209,
            columnNumber: 13
          }
        })));
      }
    }
  };
  return /*#__PURE__*/React.createElement(SelectFollowsContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SearchInput, _extends({
    ariaLabelReset: ariaLabelReset,
    cancelButton: true,
    handlers: {
      onChange: onChange,
      onClick: onSearchInputClick
    },
    resetHandlers: {
      onClick: onSearchResetClick
    },
    iconType: "search",
    inputType: "search",
    placeHolder: placeholderCopy,
    value: query
  }, searchProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 226,
      columnNumber: 7
    }
  })), renderContent());
};
export default /*#__PURE__*/React.memo(SelectFollows);